import { FormMessage } from '@readcloud/ui/form';
import React from 'react';
import { Label } from '@readcloud/ui/label';
import { Input } from '@readcloud/ui/input';
import { Card } from '@readcloud/ui/card';

interface UploadImageThumbnailProps {
  onThumbnailUpload: (data: string) => void;
}

export const UploadImageThumbnail: React.FC<UploadImageThumbnailProps> = ({
  onThumbnailUpload,
}) => {
  const [image, setImage] = React.useState<File | null>(null);
  const [base64image, setBase64Image] = React.useState<string>('');

  React.useEffect(() => {
    if (!image) {
      setBase64Image('');
      return;
    }

    const reader = new FileReader();
    reader.onload = () => {
      setBase64Image(reader.result as string);
    };
    reader.readAsDataURL(image);
  }, [image]);

  // Call onThumbnailUpload when image URL is ready
  React.useEffect(() => {
    onThumbnailUpload(base64image || '');
  }, [base64image, onThumbnailUpload]);

  return (
    <div className="rc-flex rc-flex-col rc-gap-6 rc-w-full rc-items-center">
      <div className="rc-flex rc-flex-col rc-justify-start rc-w-full rc-gap-2">
        <Label htmlFor="file">Upload Image</Label>
        <Input
          type="file"
          id="file"
          onChange={(e) => setImage(e.target.files?.[0] ?? null)}
          name={'upload-image-thumbnail'}
        />
      </div>

      <Card className="rc-overflow-hidden rc-w-44 rc-h-[234.47px]">
        {base64image && (
          <img
            src={base64image}
            alt="Uploaded Image"
            className="rc-w-44 rc-h-[234.47px] rc-object-cover"
          />
        )}
      </Card>
    </div>
  );
};
